import React, { useState } from 'react';

import { IconButton } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ReactComponent as InfoIcon } from 'pages/Teachers/ClassroomInsights/assets/tomorrow-focus-icon.svg';
import PreviewField from 'pages/Teachers/shared/PreviewField';
import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './style.module.scss';

const LearningGaps = ({ commonIssues }) => {
  const [loadAllStudents, setLoadAllStudents] = useState([]);
  const [descriptionDisplayed, setDescriptionDisplayed] = useState([]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <InfoIcon />
        <Typography variant="S-TEAXT-2" color={colors.grey2}>
          Key Learning Gaps to Address
        </Typography>
      </header>

      <Divider className={styles.divider} />
      <div className={styles.commonIssues}>
        {commonIssues &&
          commonIssues?.map((issue, idx) => (
            <div key={idx} className={styles.errorSection}>
              <header className={styles.sectionHeader}>
                <div>
                  <Typography variant="S-TEAXT-2">{issue.name}</Typography>
                </div>
                <div>
                  <div className={styles.studentCount}>
                    {issue.students.length} Students
                  </div>
                  <IconButton
                    className={styles.loadMore}
                    onClick={() => {
                      if (!descriptionDisplayed.includes(idx))
                        setDescriptionDisplayed((prev) => [...prev, idx]);
                      else
                        setDescriptionDisplayed((prev) =>
                          prev.filter((i) => i !== idx)
                        );
                    }}
                  >
                    <ExpandMoreIcon
                      style={{
                        transform: descriptionDisplayed.includes(idx)
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                  </IconButton>
                </div>
              </header>
              {descriptionDisplayed.includes(idx) && (
                <div className={styles.content}>
                  <PreviewField initialValue={issue.description} />

                  <div className={styles.students}>
                    {issue.students.length > 2 &&
                      !loadAllStudents.includes(idx) && (
                        <>
                          {issue.students.slice(0, 2).map((student, index) => (
                            <div key={index} className={styles.student}>
                              {student}
                            </div>
                          ))}
                          <div
                            className={styles.loadMore}
                            onClick={() =>
                              setLoadAllStudents((prev) => [...prev, idx])
                            }
                          >
                            + {issue.students.length - 2} more
                          </div>
                        </>
                      )}
                    {(issue.students.length < 3 ||
                      loadAllStudents.includes(idx)) && (
                      <>
                        {issue.students.map((student, index) => (
                          <div key={index} className={styles.student}>
                            {student}
                          </div>
                        ))}
                        {issue.students.length > 2 && (
                          <div
                            className={styles.loadMore}
                            onClick={() =>
                              setLoadAllStudents((prev) =>
                                prev.filter((i) => i !== idx)
                              )
                            }
                          >
                            show less
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default LearningGaps;
